export { CardAttractImage } from './CardAttractImage';
export type { CardAttractImageProps } from './CardAttractImage';
